import { fetchJson } from 'utils/fetch';

export const getByEntityId = entityId =>
  fetchJson(`/admin/access/${entityId}/customer-users`);



// WEBPACK FOOTER //
// ./src/modules/admin/api/index.js